import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { PropTypes } from "prop-types";
import { observer } from "mobx-react";
import { Button, Icon, Grid, Menu, Dropdown } from "semantic-ui-react";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import User from "~/models/User";
import LoginAsHelper from "~/utils/LoginAsHelper";
import AuthenticatedUserHelper from "~/utils/AuthenticatedUserHelper";

/**
 * Base component. You may not want to use this standalone.
 * @see TourbuzzHeader
 * @see UrbanimmersiveHeader
 */
@observer
class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      revertingIdentity: false,
    };
  }

  getWelcomeUser() {
    const { user, t } = this.props;

    if (!user.username) {
      return <h4>{t("welcome")}</h4>;
    }

    if (user.hasRevertIdentity) {
      return (
        <h4>
          <a
            href="#"
            onClick={event => {
              event.preventDefault();
              this.setState({ revertingIdentity: true });
              LoginAsHelper.revertIdentity();
            }}
          >
            {t("welcomeUserUsernameRevertIdentity", { userUsername: user.username })}
          </a>
        </h4>
      );
    }

    return <h4>{t("welcomeUserUsername", { userUsername: user.username })}</h4>;
  }

  render() {
    const { revertingIdentity } = this.state;
    const { user, t, headerContentLogo, accountMenu, navMenuElements, supportUrl } = this.props;

    return (
      <div id="header" className="header-container">
        <LoadingWrapper loading={revertingIdentity} message={t("revertingIdentity")} />
        <Grid.Row className="header-top-container primary-container ui grid">
          <Grid.Column width={9} className="header-logo-container">
            <div className="header-logo-content">{headerContentLogo}</div>
          </Grid.Column>
          <Grid.Column width={7} className="header-controls-container">
            <a href={supportUrl} target="_blank" rel="noopener noreferrer">
              <Button className="icon info header-support-btn">
                <Icon name="info circle" />
                <span className="header-btn-span">{t("support")}</span>
              </Button>
            </a>

            <Dropdown icon="bars" floating button className="custom-domain-dropdown-mobile">
              <Dropdown.Menu position="right">
                {window.templateDefaults.headerLinks.map((headerLink, index) => (
                  <Dropdown.Item
                    /* eslint-disable-next-line react/no-array-index-key */
                    key={index}
                    href={headerLink.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="header-custom-domain-link-mobile"
                    as="a"
                  >
                    {headerLink.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {window.templateDefaults.headerLinks.map((headerLink, index) => (
              <a
                /* eslint-disable-next-line react/no-array-index-key */
                key={index}
                href={headerLink.url}
                target="_blank"
                rel="noopener noreferrer"
                className="header-custom-domain-link"
              >
                {headerLink.label}
              </a>
            ))}
            {AuthenticatedUserHelper.isAuthenticated(user) && (
              <Dropdown
                text={t("clientPanelInfo:myAccount")}
                icon="user"
                floating
                button
                className="header-account-btn"
              >
                {accountMenu}
              </Dropdown>
            )}
          </Grid.Column>
        </Grid.Row>

        <div id="nav" className="nav-container">
          <Menu size="small">
            {navMenuElements.map((element, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Menu.Item key={index}>{element}</Menu.Item>
            ))}
            <Menu.Item position="right">{this.getWelcomeUser()}</Menu.Item>
          </Menu>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  user: PropTypes.instanceOf(User),
  t: PropTypes.func.isRequired,
  headerContentLogo: PropTypes.node.isRequired,
  accountMenu: PropTypes.node.isRequired,
  navMenuElements: PropTypes.arrayOf(PropTypes.node),
  supportUrl: PropTypes.string.isRequired,
};

Header.defaultProps = {
  navMenuElements: [],
};

export default withTranslation()(Header);
